import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles } from 'actions';
import {
	GetTasksRequest,
	GetTasksDropdownsRequest,
	EditTasksDetailsRequest,
	ExportBridgesRequest,
	CreateNewBridgeRequest,
	UploadStatusFileRequest,
	DownloadTemplateRequest,
	CloseBridgeRequest,
	GetBridgeStatusRequest,
	GetLastBridgeSummaryTablesRequest,
	GetMOCNTableRequest,
	GetProximityTableRequest
} from '../requests/BridgeCallRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_TASKS = 'GET_TASKS';
export const GET_TASKS_DROPDOWNS = 'GET_TASKS_DROPDOWNS';
export const TOGGLE_BRIDGE_CREATION_DIALOG = 'TOGGLE_BRIDGE_CREATION_DIALOG';
export const UPLOAD_STATUS_FILE = 'UPLOAD_STATUS_FILE';
export const DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE';
export const GET_SUMMARY_TABLES = 'GET_SUMMARY_TABLES';
export const GET_MOCN_TABLE = 'GET_MOCN_TABLE';
export const GET_PROXIMITY_TABLE = 'GET_PROXIMITY_TABLE';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetTasks = value => ({
	type: GET_TASKS,
	tasks: value
});

const onGetSummaryTables = value => ({
	type: GET_SUMMARY_TABLES,
	summaryTables: value
});

const onGetMOCNTable = value => ({
	type: GET_MOCN_TABLE,
	mocnTable: value
});

const onGetProximityTable = value => ({
	type: GET_PROXIMITY_TABLE,
	proximityTable: value
});

const onGetTasksDropdowns = value => ({
	type: GET_TASKS_DROPDOWNS,
	dropdowns: value
});

const onToggleCreationBridgeCallDialog = visible => ({
	type: TOGGLE_BRIDGE_CREATION_DIALOG,
	visible
});

const onUploadStatusFile = () => ({
	type: UPLOAD_STATUS_FILE
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetTasks = (userId) => async dispatch => {
	await GetTasksRequest(userId)
		.then(response => {
			dispatch(onGetTasks(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetTasksDropdowns = (
	userId,
	tableId
) => async dispatch => {
	await GetTasksDropdownsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetTasksDropdowns(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const EditTasksDetails = bridgeCallDto => async dispatch => {
	await EditTasksDetailsRequest(bridgeCallDto)
		.then(response => {
			dispatch(GetTasks());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ExportBridges = (userId) => async dispatch => {
	await ExportBridgesRequest(userId)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const DownloadTemplate = (userId) => async dispatch => {
	await DownloadTemplateRequest(userId)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UploadStatusFile = (userId, file) => async dispatch => {
	await UploadStatusFileRequest(userId, file).then(response => {
		dispatch(enqueueSnackbar({
			message: "File uploaded successfully.",
			options: { variant: "success" }
		}));
	}).catch(error => {
		if (error) {
			dispatch(
				enqueueSnackbar({
					message: error.message,
					options: { variant: error.variant }
				})
			);
		}
	});
};

export const CreateNewBridge = (userId) => async dispatch => {
	await CreateNewBridgeRequest(userId)
		.then(response => {
			dispatch(GetTasks(userId));
			dispatch(enqueueSnackbar({ message: "New Bridge Created", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const CloseBridge = (userId) => async dispatch => {
	await CloseBridgeRequest(userId)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(GetTasks(userId));
			dispatch(enqueueSnackbar({ message: "The bridge has been closed.", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetBridgeStatus = (userId) => async dispatch => {
	await GetBridgeStatusRequest(userId)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(enqueueSnackbar({ message: "Bridge status ready for download.", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetLastBridgeSummaryTables = (userId) => async dispatch => {
	await GetLastBridgeSummaryTablesRequest(userId)
		.then(response => {
			dispatch(onGetSummaryTables(response.data));
			//dispatch(enqueueSnackbar({ message: "Bridge status ready for download.", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetMOCNTable = (userId) => async dispatch => {
	await GetMOCNTableRequest(userId)
		.then(response => {
			dispatch(onGetMOCNTable(response.data));
			//dispatch(enqueueSnackbar({ message: "Bridge status ready for download.", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetProximityTable = (userId) => async dispatch => {
	await GetProximityTableRequest(userId)
		.then(response => {
			dispatch(onGetProximityTable(response.data));
			//dispatch(enqueueSnackbar({ message: "Bridge status ready for download.", options: { variant: "Info" } }));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleCreationBridgeCallDialog = visible => dispatch => {
	dispatch(onToggleCreationBridgeCallDialog(visible));
};
